var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77778 18.6667C5.48222 18.6667 2 15.6819 2 12C2 8.3181 5.48222 5.33333 9.77778 5.33333M9.77778 18.6667C14.0733 18.6667 17.5556 15.6819 17.5556 12M9.77778 18.6667L9.77778 22M9.77778 5.33333C14.0733 5.33333 17.5556 8.3181 17.5556 12M9.77778 5.33333L9.77778 2M17.5556 12L9.28222 12M9.28222 12C8.87944 12 8.48422 12.1094 8.13889 12.3167L3.11111 15.3333M9.28222 12C8.87944 12 8.48422 11.8906 8.13889 11.6833L3.11111 8.66667M16.4444 16.3044C16.7996 16.3958 17.1719 16.4444 17.5556 16.4444C20.0102 16.4444 22 14.4546 22 12C22 9.5454 20.0102 7.55556 17.5556 7.55556C17.1719 7.55556 16.7996 7.60417 16.4444 7.69558M14.2222 18.6667L16.4444 20.8889M5.33333 18.6667L3.11111 20.8889M14.2222 5.33333L16.4444 3.11111M5.33333 5.33333L3.11111 3.11111",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBug);
export default __webpack_public_path__ + "static/media/bug.291f11168de25dd9371ec6c0560aec0f.svg";
export { ForwardRef as ReactComponent };